import type { MechKey } from './keys';

export const es: Partial<Record<MechKey, string>> = {
  'app.eyebrow': 'Mecánica · 2D',
  'panel.scene': 'Escena',
  'panel.dims': 'Parámetros',
  'panel.style': 'Apariencia',
  'panel.action': 'Controles',
  'style.body': 'Cuerpo',
  'style.vector': 'Vectores',
  'style.ground': 'Suelo',
  'style.forces': 'Mostrar fuerzas',
  'style.trace': 'Mostrar traza',
  'style.labels': 'Etiquetas vectoriales',
  'hint.line1': 'Haz clic en reproducir para iniciar · arrastra los cuerpos para moverlos',
  'hint.line2': 'Sandbox: elige una forma y haz clic para colocarla',
  'scene.incline': 'Plano inclinado',
  'scene.projectile': 'Movimiento de proyectil',
  'scene.pendulum': 'Péndulo',
  'scene.springMass': 'Sistema masa-resorte',
  'scene.collisions': 'Colisiones',
  'scene.atwood': 'Máquina de Atwood',
  'scene.circular': 'Movimiento circular',
  'scene.sandbox': 'Sandbox',
  'dim.angle': 'ángulo (°)',
  'dim.friction': 'fricción',
  'dim.mass': 'masa',
  'dim.massA': 'masa A',
  'dim.massB': 'masa B',
  'dim.velocity': 'velocidad',
  'dim.angleLaunch': 'ángulo de lanzamiento (°)',
  'dim.gravity': 'gravedad',
  'dim.gravityX': 'gravedad x',
  'dim.gravityY': 'gravedad y',
  'dim.length': 'longitud',
  'dim.damping': 'amortiguación',
  'dim.spring': 'rigidez',
  'dim.restitution': 'restitución',
  'dim.radius': 'radio',
  'dim.speed': 'rapidez',
  'action.play': 'Reproducir',
  'action.pause': 'Pausar',
  'action.step': 'Paso',
  'action.reset': 'Restablecer',
  'action.speed': 'Velocidad',
  'action.clear': 'Limpiar',
  'force.gravity': 'Fg',
  'force.normal': 'N',
  'force.friction': 'Ff',
  'force.tension': 'T',
  'force.spring': 'Fs',
  'force.applied': 'Fa',
  'force.air': 'Fd',
  'forceName.gravity': 'Gravedad',
  'forceName.normal': 'Normal',
  'forceName.friction': 'Fricción',
  'forceName.tension': 'Tensión',
  'forceName.spring': 'Resorte',
  'forceName.applied': 'Aplicada',
  'forceName.air': 'Resistencia del aire',
  'palette.box': 'Caja',
  'palette.circle': 'Pelota',
  'palette.ramp': 'Rampa',
  'palette.ground': 'Suelo',
  'palette.hint': 'Elige una forma y haz clic en el lienzo para colocarla.',
  'panel.forces': 'Fuerzas observadas',
  'forces.empty': 'Ninguna aún — reproduce la escena',
};
